'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _install = require('./install');

Object.defineProperty(exports, 'install', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_install).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }